<template>
  <default-layout>
    <div :id="ID_JSS_LAYOUT_DEFAULT" class="outer">
      <!-- TODO: This div should be a main but in order to do that we need to remove all the other mains -->
      <div
        class="page"
        ref="page"
        tabindex="-1"
      >
        <slot>
          <nuxt />
        </slot>
      </div>
    </div>
  </default-layout>
</template>

<script>
import { ID_JSS_LAYOUT_DEFAULT } from '~/constants/integration'
import DefaultLayout from '~/layouts/default'

export default {
  name: 'JssLayout',

  authenticated: false,

  middleware: [
    'initializer'
  ],

  components: {
    DefaultLayout
  },

  data () {
    return {
      ID_JSS_LAYOUT_DEFAULT
    }
  }
}
</script>
